import type { NewsPost } from './types.js';

export const post: NewsPost = {
  slug: '2026-09-03-voice-scribe',
  title: 'Rescue Ally 2.0: Voice Scribe is here!',
  date: '2026-09-03',
  video: {
    src: '/news/voice-scribe.mp4',
    poster: '/news/voice-scribe-poster.webp',
    label: 'Voice Scribe filling in an assessment from a spoken patient interview'
  },
  share: '/news/voice-scribe-share.jpg',
  description:
    'Rescue Ally 2.0 adds Voice Scribe, Guide Search, redesigned vitals and a CPR timer, and a look at what we are building next.',
  markdown: `What's new in 2.0:

  * Voice Scribe: Speak the patient interview or narrate as you work, and Scribe fills in vitals, chief complaints, SAMPLE history and treatments for you to review. It runs entirely on your phone - no cell service needed. [Watch the full demo here.](/demo/scribe/)
  * Guide Search: Find essential reference information by searching the field guide using the observations in your patient assessment.
  * Redesigned vitals. Trends over time, Glasgow Coma Scale scoring, improved Bluetooth monitor readings, and an improved experience for multiple patients.
  * CPR timer. Compression-rate metronome, rescue-breath prompts and total CPR time.

What we're cooking:

  * Rescue Ally for Teams: at SARCon later this month, we'll be looking for teams that are interested in taking it to the next level with dedicated SAR team features. [Check out what we're planning!](https://rescueally.org/teams)
  * Rescue Ally Scenarios: Are you confident your skills will be there when you need them? We're building scenario practice games based on real accidents that will keep your knowledge fresh between recertifications. Better than flashcards - take turns acting out rescuer and patient with your teammates, or step through a high-pressure practice scenario while you're waiting for the coffee to brew.
`
};
